import { css } from '@emotion/react';
import { Theme } from '@mildang/mui';

// 계정 찾기·비밀번호 재설정 다이얼로그가 같이 쓴다. Mui class가 없는 전역 스타일은 @layer 밖에 들어가 테마의 Dialog 스타일보다 앞선다.
export const globalStyle = css`
  .LoginScreen_Dialog_Paper {
    border-radius: 8px;
    max-width: 500px;
    width: calc(100% - 48px);
    margin: 24px;
  }
`;
export const textFieldWrapperStyle = css`
  margin-top: 20px;
`;

export const dialogTitleStyle = css`
  padding-top: 24px;
  padding-bottom: 0px;
`;
export const formStyle = css`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
export const fieldsetStyle = css`
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 16px;
`;
export const dialogContentTextStyle = (theme: Theme) => css`
  font-size: ${theme.typography.pxToRem(16)};
  padding-top: 20px;
  margin-bottom: 0px;
`;
export const dialogActionsStyle = (theme: Theme) => css`
  padding: 16px 24px;
  background-color: ${theme.palette.background.secondary};
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 8px;
  justify-content: flex-end;
  margin-top: 8px;
`;
